export const SPECIALTIES_OPTIONS = [
  'Cardiology', 'Orthopedics', 'Neurology', 'Oncology', 'Gastroenterology',
  'Pulmonology', 'Nephrology', 'Urology', 'Ophthalmology', 'ENT',
  'Dermatology', 'Psychiatry', 'Pediatrics', 'Gynecology', 'Obstetrics',
  'General Surgery', 'Plastic Surgery', 'Dental', 'Fertility & IVF',
  'Bariatric Surgery', 'Spine Surgery', 'Transplant', 'Ayurveda'
];

export const TREATMENTS_OPTIONS = [
  'Heart Bypass Surgery', 'Angioplasty', 'Knee Replacement', 'Hip Replacement',
  'Spine Surgery', 'Brain Surgery', 'Cancer Treatment', 'Chemotherapy',
  'Kidney Transplant', 'Liver Transplant', 'IVF Treatment', 'Dental Implants',
  'Cosmetic Surgery', 'Hair Transplant', 'Bariatric Surgery', 'Eye Surgery'
];

export const FACILITIES_OPTIONS = [
  '24/7 Emergency', 'ICU', 'NICU', 'Operation Theaters', 'Blood Bank',
  'Pharmacy', 'Diagnostic Lab', 'MRI', 'CT Scan', 'Ambulance Service',
  'International Patient Lounge', 'Visa Assistance', 'Airport Pickup',
  'Interpreter Services', 'Private Rooms', 'VIP Suites'
];

export const ACCREDITATION_OPTIONS = [
  'NABH', 'JCI', 'NABL', 'ISO 9001:2015', 'ISO 14001', 'QAI', 'AHPI'
];

export const LANGUAGES_OPTIONS = [
  'English', 'Hindi', 'Arabic', 'Russian', 'French', 'German', 
  'Spanish', 'Mandarin', 'Bengali', 'Tamil', 'Telugu', 'Kannada', 'Malayalam'
];

export const QUALIFICATION_OPTIONS = [
  'MBBS', 'MD', 'MS', 'DM', 'MCh', 'DNB', 'FRCS', 'MRCP', 'PhD',
  'Fellowship', 'BDS', 'MDS', 'BAMS', 'BHMS'
];

export const CERTIFICATION_OPTIONS = [
  'Board Certified', 'FACC', 'FACS', 'FRCP', 'ESC Member', 
  'AHA Certified', 'ACLS Certified', 'BLS Certified'
];

export const SUB_SPECIALIZATION_OPTIONS = {
  'Cardiology': ['Interventional Cardiology', 'Cardiac Electrophysiology', 'Heart Failure', 'Preventive Cardiology', 'Pediatric Cardiology'],
  'Orthopedics': ['Joint Replacement', 'Spine Surgery', 'Sports Medicine', 'Trauma Surgery', 'Pediatric Orthopedics'],
  'Neurology': ['Stroke', 'Epilepsy', 'Movement Disorders', 'Neuromuscular', 'Pediatric Neurology'],
  'Oncology': ['Medical Oncology', 'Surgical Oncology', 'Radiation Oncology', 'Hematologic Oncology', 'Pediatric Oncology'],
  'Gastroenterology': ['Hepatology', 'IBD', 'Endoscopy', 'Pancreatic Diseases', 'Motility Disorders'],
  'default': ['General Practice', 'Specialized Care', 'Emergency Medicine', 'Critical Care']
};

export const AVAILABILITY_OPTIONS = [
  'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
];
